import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domestic-policy',
  templateUrl: './domestic-policy.component.html',
  styleUrls: ['./domestic-policy.component.scss']
})
export class DomesticPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
